"use strict";

module.exports = function (accumulator, order) {
  var addition = order.name.replace(/[, ]*/g, '');

  if (accumulator.length && addition.length) {
    return accumulator + '-' + addition;
  }

  return addition;
};